import { Component, Input, OnInit } from '@angular/core';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { DataService } from 'src/app/services/data.service';
import { AppService } from "src/app/services/app.service";
import { BankDocumentInfo } from 'src/app/models/document';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { Router, ActivatedRoute, Params, NavigationEnd } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  AbstractControl,
  FormArray,
  NgForm,

} from "@angular/forms";
import { finalize, first } from 'rxjs/operators';
import { CustomValidators } from "ng2-validation";
import { HttpClient, HttpErrorResponse, HttpEvent, HttpRequest } from '@angular/common/http';
import { style } from '@angular/animations';
import { element } from 'protractor';
import { Observable } from 'rxjs/internal/Observable';
import { isNgTemplate } from '@angular/compiler';


@Component({
  selector: 'app-corp-digital-upload',
  templateUrl: './corp-digital-upload.component.html',
  styleUrls: ['./corp-digital-upload.component.scss']
})
export class CorpDigitalUploadComponent implements OnInit {
  myFile: string[] = [];
  myFile1: string[] = [];
  myFile2: string[] = [];
  step: any;
  stepp: any
  idDocUploadedData: any;
  idDocUpload: string;
  accountID: string | Blob;
  bankDocUploadedData: any;
  bankDocUpload: string;
  stateField: boolean = false;
  copmanyAccountInfoData: any;
  docArray: BankDocumentInfo[] = [
    // {key:"IDENTITY", value:'IDENTITY'},
    // {key:"ADDRESS", value:'ADDRESS'},
    { key: "LEGAL", value: 'LEGAL' },
    { key: "FINANCE", value: 'FINANCE' },
    { key: "CORPORATE", value: 'CORPORATE' },
  ];
  docForm: FormGroup;
  docNameData: any;
  docNameArray: any;
  doctype: any;
  docName: any;
  docUploadedData: any;
  docUpload: string;
  inputField: boolean = false;
  isRefreshed: boolean = false;
  docUploaded: any;
  bankDocUpload2: string;
  imageUrl1: any;
  images3Url1: any;
  states: any = [{}];
  imageUrl2: any;
  images3Url2: any;
  isTrue: boolean = false;
  isTrue1: boolean = false;
  docList: any=[];
  checkId: any;
  stateVal: any = "";
  idNo: boolean = false;
  countryCode: any;
  openModal:any=null;
  @Input() checks:any;
  docuName: any=null;
  documentNo: any=null;
  documentName: any;

  constructor(
    private formBuilder: FormBuilder,
    private _data: DataService,
    private _app: AppService,
    public router: Router,
    public route: ActivatedRoute,
    private http: HttpClient) { }


  ngOnInit() {
    //this._data.changeLoaderVisibility(true);
    this.goto("1", "1");
    this.getAccountInfo()
    this.docForm = this.formBuilder.group({
      documentName: [''],
      documentNo: ['']
    })
  }
  stateSelected(event) {
    this.stateVal = event;
  }
  getAccountInfo() {
    this._app.getAccountInfoforCorp().pipe(first()).subscribe((data) => {
      this.copmanyAccountInfoData = data["data"]
      this.accountID = this.copmanyAccountInfoData.accountId
      console.log(this.accountID);
      this._app.getCompanyInfo(this.accountID).subscribe((res) => {
        this.countryCode = res.data.country.countryCode
        this._app.getStates(this.countryCode).subscribe((response) => {
          this.states = response.data;
        });
      });
      this._app.getDocList(this.accountID).subscribe((response) => {
        this.docList = response
        console.log("Data: ", this.docList);
      });
    })
  }

  checkType(val) {
    this.doctype = val
    console.log("Doc Type: ", this.doctype);
    if (this.doctype === "IDENTITY") {
      this.idNo = true
    }
    else {
      this.idNo = false;
    }
    if (this.doctype === "ADDRESS") {
      this.stateField = true
    }
    else {
      this.stateField = false;
    }
    this.getDocName(this.doctype)
  }

  checkName(val) {
    console.log("this si ",val)
    this.docName = val
    if (this.docName !== null) {
      this.isTrue = true
      this.isTrue1 = true
    }
    var docNameP = val
    if (docNameP.substring(0, 5) === "Other") {
      this.inputField = true
    }else{
      this.inputField = false;
    }
  }

  getName() {
    if(this.inputField){
      this.docName = this.documentName
    } 
  }

  getDocName(id) {
    this._app.getDocName(id).pipe(first()).subscribe((data) => {
      this.docNameData = data["data"]
      console.log(this.docNameData);
      this.docNameArray = this.docNameData
    })
  }

  goto(n, m) {
    this.step = n,
      this.stepp = m
  }


  gotoBack() {
    this.step = false
    this.stepp = false
    this.openModal=null
  }
  getCheckId(val) {
    this.checkId = val
    console.log(this.checkId);

  }

  onUpload(event, item) {
    item.array = new Array()
    item.size = 0
    console.log("OnUpload: ", event)
  }

  getFileDetails(e, item) {
    console.log("Address Docs Files: ", e.target.files);
    for (var i = 0; i < e.target.files.length; i++) {
      item.array.push(e.target.files[i]);
    }
    item.size = 1
    console.log("Uploaded Files: ", item.array)
  }
  uploadFiles(item, val, val1) {
    const formData = new FormData()
    formData.append("frontImage", item.array[0])
    formData.append("accountId", this.accountID)
    formData.append("checkId", val1)
    formData.append("docName", val)
    this._data.changeLoaderVisibility(true);
    this._app.getIdDocUploadforCorp(formData).subscribe(data => {
      this.idDocUploadedData = data["data"]
      this._data.toastrShow('Documents successfully uploaded', `success`)
      this._data.changeLoaderVisibility(false);
      item.upload = true
      item.array = new Array()
      this.images3Url1 = this.idDocUploadedData.docPathF
      this.getAccountInfo()

    }
    );
    //this.getViewDoc1(this.images3Url1)
    this.isRefreshed = !this.isRefreshed
    item.array = new Array()
  }
  cancelUpload(item) {
    item.array = new Array()
    item.size = 0
  }

  getViewDoc1(id) {
    console.log('Image Url 1');
    let abc = {
      s3url: id,
    };
    this._app.getViewDoc(abc).subscribe((data) => {
      this.imageUrl1 = data['data'];
    });
  }

  

  getFileDetails2(e) {
    console.log("Address Docs Files: ", e.target.files);
    for (var i = 0; i < e.target.files.length; i++) {
      this.myFile2.push(e.target.files[i]);
    }
    console.log("Uploaded Files: ", this.myFile2)
  }
  uploadFiles2() {
    if(!this.inputField){
      const formData = new FormData()
      formData.append("frontImage", this.myFile2[0])
      formData.append("accountId", this.accountID)
      formData.append("docName", this.docName)
      formData.append("idNumber", this.documentNo)
      formData.append("stateCode", this.stateVal);
      this._data.changeLoaderVisibility(true);
      this._app.getIdDocUploadforCorp(formData).subscribe(data => {
        this.docUploaded = data
        this.docUploadedData = data["data"]
        this._data.toastrShow('Documents successfully uploaded', `success`)
        this._data.changeLoaderVisibility(false);
        this.idNo = false
        this.myFile2 = new Array()
        this.getAccountInfo()

      }
      );
      this.isRefreshed = !this.isRefreshed
      this.myFile2 = new Array()
    }
    else{
      this.uploadAdHock('UNKNOWN')
    }
    this.inputField=false;
    this.documentName=''

      
  }
  uploadAdHock(type){
    const formData = new FormData()
    formData.append("frontImage", this.myFile2[0]);
    formData.append("accountId", this.accountID);
    formData.append("docName", this.docName);
    formData.append("kysDocType", type);
    this._data.changeLoaderVisibility(true);
    this._app.getDocumentAdHockUpload(formData).pipe(finalize(() => this._data.changeLoaderVisibility(false))).subscribe(() => {
      this._data.toastrShow('Documents successfully uploaded', `success`);
      this.isRefreshed = !this.isRefreshed
      this.myFile2 = new Array()
      this.getAccountInfo()
    })
  }
  cancelUpload2() {
    this.myFile2 = []
  }

  gotoNext() {
    this._data.digitalVal(true);
    let status={
      "kysTpeCheckHeading":"DIGITAL_UPLOAD",
      "kysTpeCheckStatus":"PASSED"
    }
    this._app.sendStatus(status).subscribe(response=>{
      this._app.getStatus().subscribe(res=>{
        this._data.assignStatus(res)
      })
    })
    this._data.toastrShow('Your Details have been saved successfully', `success`)
  }


  getFinalSubmit() {
    let abc;
    this._data.changeLoaderVisibility(true);
    this._app.getFinalSubmit(abc).pipe(finalize(() => this._data.changeLoaderVisibility(false))).subscribe((response) => {
      this._data.toastrShow(`All details submitted Successfully`, 'success');
      
      const payload = {
        "message": 'Company details submitted Successfully',
        "page": "Company Final Submit",
        "geoLocation": null
      }
      this._data.finishVal(true)
      this._app.feasAddActivityLog(localStorage.getItem("companyKysNo"), payload).subscribe();
    },
      (err: HttpErrorResponse) => {
        const payload = {
          "message": err,
          "page": "Company Final Submit",
          "geoLocation": null
        }
        this._app.feasAddActivityLog(localStorage.getItem("companyKysNo"), payload).subscribe();
      }
    );
  }

}

